import { useEffect } from "react";

export default function useClickOutside(
  ref: React.RefObject<HTMLInputElement | HTMLTextAreaElement | HTMLDivElement | null>,
  callback: () => void,
  containerRef?: React.RefObject<HTMLElement | null>
) {
  useEffect(() => {
    function onClickOutside(e: MouseEvent) {
      const target = e.target as Node;
      if (!callback || ref.current === null) return;
      if (ref.current.contains(target)) return;
      if (containerRef?.current?.contains(target)) return;
      callback();
    }

    document.addEventListener("click", onClickOutside, true);

    return () => {
      document.removeEventListener("click", onClickOutside, true);
    };
  }, [callback, ref, containerRef]);
}
